module.exports = __webpack_public_path__ + "glyphicons-filetypes-regular.3ab34b78fb3c096f346e.woff";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.filetypes.pro/glyphicons-filetypes-regular.woff
// module id = ../../../../../src/assets/css/fonts/glyphicons.filetypes.pro/glyphicons-filetypes-regular.woff
// module chunks = 2